
import { on } from './modules/_fn';

function fixedNav() {
	const $contentNav = document.querySelector('.js-fixed-nav');

	if ($contentNav) {
		const $contentNavLine = $contentNav.querySelector('.content-nav_line');
		const $contentNavInner = $contentNav.querySelector('.content-nav_inner');

		if (isInViewport($contentNavLine)) {
			const $header = document.querySelector('.hd.is-collapse');
			let navHeight = $contentNav.offsetHeight;

			$contentNav.classList.add('is-fixed');
			$contentNav.style.top = (-navHeight/2 ) + "px";
			$contentNavLine.style.height = navHeight + "px";
			$contentNavInner.style.top = $header ? $header.offsetHeight + 'px' : null;
		} else {
			$contentNav.classList.remove('is-fixed');
			$contentNav.style.top = null;
			$contentNavLine.style.height = null;
			$contentNavInner.style.top = null;
		}
	}
}

function isInViewport(el) {
	const $header = document.querySelector('.hd.is-collapse');
	let rect = el.getBoundingClientRect();
	let headerH = $header ? $header.offsetHeight : 0;

	return (
		rect.right >= 0 &&
		rect.top <= headerH &&
		rect.left <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

on(window, 'load', fixedNav);
on(window, 'scroll', fixedNav);
on(window, 'resize', fixedNav);
